
const API_SERVICES  =  {
    TABLE_RECORD_SIZE:10,
    TABLE_RECORD_OPTIONS:[1,2,3,5,10,20,30,40,50],
    CIN_PATTERN:'([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$',
    PASSWORD_PATTERN:'(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{6,16}$',
    PAN_PATTERN:'[A-Z]{5}[0-9]{4}[A-Z]{1}$',
    GSTN_PATTERN:'^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[A-Z]{1}[0-9A-Z]{1}$',
    DECIMAL_PLACE:'^[0-9]+(.[0-9]{1,2})?$',
    MOBILE_PATTERN:'^[0-9]{10}$',
    LIST_CONSTITUTION:[    
        { label: 'Company', value: 'Company' },    
        { label: 'Partnership', value: 'Partnership' },    
        { label: 'Sole Proprietorship', value: 'Sole_Proprietorship' },    
        { label: 'Individual', value: 'Individual' },    
        { label: 'Trust', value: 'Trust' },    
      ],
      CIN_CHARACTER_NUMBER_FORMAT:'a99999aa9999aaa999999',
      PAN_CHARACTER_NUMBER_FORMAT:'aaaaa9999a',
      EMPTY_VALUE:'N/A',

}

export default API_SERVICES;
